import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { white, black200, black700, black600, black400, cinnabar300, blue300 } from '../../../theme/colors';
import themeSizes from '../../../theme/themeSizes';
import { baseCaption } from '../../../theme/typography';

const textboxStyle = `
    min-height: 38px;
    border-radius: 8px;
    box-sizing: border-box;
    color: ${black700}; 
    display: flex;   
    flex-wrap: wrap;
    position: relative;
    transition: all 0.2s ease-in-out;
`;

const TextBoxStyle = styled.div`
    ${baseCaption};
    width: ${({ boxWidth }) => boxWidth || 'auto'};
    max-width: 100%;
    box-sizing: border-box;
    position: relative;
    @media (max-width: 995px) {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        >div {
            width: ${props => props.isOutSide ? "calc(100% - 40px)" : "100%"} !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
        }
    }
    >div{
        ${textboxStyle};
        padding: ${({ boxPadding }) => boxPadding || '8px 14px'}; 
        margin: ${({ boxMargin }) => boxMargin}; 
        width: ${({ boxWidth }) => boxWidth || `540px`};
        max-width: 100%;
        box-sizing: border-box;
        max-width: ${({ isSearchBox }) => isSearchBox && `280px`};
        background: ${({ isSearchBox, background }) => isSearchBox ? `#f8fafc` : background || `${white}`};
        border-radius: ${({ isSearchBox }) => isSearchBox ? `12px` : `8px`};
        border: ${({ isSearchBox }) => isSearchBox
        ? `1.5px solid #e2e8f0`
        : `1px solid ${black200}`};
        box-shadow: ${({ isSearchBox }) => isSearchBox ? `0 1px 3px rgba(0,0,0,0.04)` : `none`};
        ${props => props.noBorder && css`
            border: none
        `}
        ${props => props.errorLine && css`
            border: 1px solid ${cinnabar300} !important;
        `}
        &:focus-within {
            border-color: ${({ isSearchBox }) => isSearchBox ? `#6366f1` : `#3b82f6`} !important;
            box-shadow: ${({ isSearchBox }) => isSearchBox
        ? `0 0 0 3px rgba(99,102,241,0.15), 0 4px 12px rgba(99,102,241,0.08)`
        : `0 0 0 3px rgba(59,130,246,0.15)`} !important;
            background: ${({ isSearchBox }) => isSearchBox ? `#fafafe` : `${white}`} !important;
        }
        align-items: center;
        min-height: ${({ boxHeight }) => boxHeight || `38px`};
        input{
            border:none;
            outline:none;
            flex:1;
            min-width: 1px; 
            width:0;
            background: transparent;
            ${baseCaption}
            ::placeholder {
                color: #94a3b8;
            }
        }
        span {
            svg{
                width:18px;
                height:18px;
                vertical-align: -6px;
                color: ${({ isSearchBox }) => isSearchBox ? `#6366f1` : `inherit`};
            }
        } 
        :after{
            ${props => props.disabled && css`
                cursor: not-allowed;
                content:' ';
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
                border-radius: 8px;
            `}
        }
        @media (max-width: 995px) {
            width:100% !important;
            max-width: 100% !important;
          }
    } 
    /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        }

        /* Firefox */
        input[type=number] {
        -moz-appearance: textfield;
        }
        
`;

const FileBoxStyle = styled.div`
     ${baseCaption}
     width: ${({ boxWidth }) => boxWidth || 'auto'};
     position: relative;
     @media (max-width: 995px) {
          width: 100% !important;
          max-width: 100% !important;
          &>div {
              width: ${props => props.isOutSide ? "calc(100% - 40px)" : "100%"} !important;
              max-width: ${props => props.isOutSide ? "calc(100% - 40px)" : "100%"} !important;
          }
     }
    &>div{
        ${textboxStyle}
        cursor: pointer;
        padding-left:16px;
        background:${(props) => props.check === "ekyc" && "#EAEAEA"};
        width: ${({ boxWidth }) => boxWidth || `540px`};
        margin: ${({ boxMargin }) => boxMargin};
        border-radius: 8px;
        border: ${({ isSearchBox }) => !isSearchBox && `1px solid ${black200}`}; 
        ${props => props.errorLine && css`
            border: 1px solid ${cinnabar300};
        `};
        &:hover {
            border-color: #cbd5e1;
        }
        &>span{
            flex:1;
            padding:12px 0;
            overflow-x:auto;
            display:inline-block;
            white-space: nowrap;
            margin-right:4px;
            color:${props => props.isPlaceholder ? black400 : black700};
        }
        input{
            display:none;
        }
        :after{
            ${props => props.disableEntireRow && css`
                cursor: not-allowed;
                content:' ';
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
                border-radius: 8px;
            `};
        }
        label{
            background: ${(props) => props.check === "ekyc" ? props.btbgColor : black600};
            position: relative;
            padding: 10px 16px;
            border-radius: 6px;
            color: ${white};
            ${baseCaption};
            cursor: pointer;
            display:flex;
            align-items:center;
            transition: all 0.2s ease;
            &:hover {
                filter: brightness(0.9);
            }
            @media (max-width: 500px) {
                padding:5px;
              }
            :after{
            ${props => props.disabled && css`
                cursor: not-allowed;
                content:' ';
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
                z-index:3;
                border-radius: 6px;
            `};
        }
        }
        svg{
            ${props => props.isOutSide && css`
                position: absolute;
                right: -36px;
                top: 4px;
            `};
            @media (max-width: 500px) {
                display:none;
              }
        }
        @media (max-width: 995px) {
            width:100% !important;
          }
       
    }
`;

const OutSideIcon = styled.span`
        position: absolute;
        right: -36px;
        top: 10px;
`;

const MessageBelowBoxStyle = styled.p`
    ${baseCaption}
    margin: 6px 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    width: ${({ boxWidth }) => boxWidth || `auto`};
    @media (max-width: 995px) {
        width: 100% !important;
    }
    
    &>span:first-child {
        color: ${cinnabar300};
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        order: 1;
        ${props => props.cursorPointer && css`
            cursor:pointer;
        `}
        ${props => props.subTextDisabled && css`
            cursor:not-allowed;
        `}
    }
    &>span:last-child {
        color: ${blue300};
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        order: 2;
        ${props => props.cursorPointer && css`
            cursor:pointer;
        `}
        ${props => props.subTextDisabled && css`
            cursor:not-allowed;
        `}
    }
`;

const TextAreaStyle = styled.div`
    ${baseCaption};
    width: ${({ boxWidth }) => boxWidth || 'auto'};
    @media (max-width: 995px) {
        width: 100% !important;
    }
    padding: ${props => `${props.isSKU && 0} !important`};
    overflow: ${props => props.isSKU && 'hidden'};
    &>div:first-child{
        ${textboxStyle};
        border-radius: 8px;
        padding: 12px 0 12px 16px; 
        width: ${({ boxWidth }) => boxWidth || `540px`};
        height: ${({ boxHeight }) => boxHeight || `160px`};
        border: 1px solid ${black200};
        ${props => props.errorLine && css`
            border: 1px solid ${cinnabar300};
        `};
        &:focus-within {
            border-color: #3b82f6 !important;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;
        }
        overflow-y: auto;
        
        textarea{
            border:none;
            outline:none;
            resize: none;
            width:0;
            flex:1;
            background: ${({ isSearchBox, background }) => isSearchBox ? `transparent` : background || `${white}`};
            ${baseCaption}
            ::placeholder {
                color: #94a3b8;
            }
        };
        @media (max-width: 995px) {
            width:100% !important;
          }
    }
`;

export const DashboardTextBox = ({
    type = 'text',
    placeholder = 'Enter text',
    name,
    value = '',
    rightIcon = '',
    outsideIcon,
    warnMessage = {
        align: 'right',
        errorLine: true
    },
    subText = {},
    customStyles,
    textareaStyles,
    onChange = () => { },
    onClick = () => { },
    onEnter = () => { },
    handleRightIconClick,
    handleOutsideIconClick,
    isSearchBox = false,
    fieldName,
    boxWidth,
    disabled,
    background,
    boxHeight,
    boxPadding,
    boxMargin,
    fileAcceptType = '',
    disableEntireRow = false,
    readOnly = false,
    noBorder = false,
    isSKU = false,
    check,
    btbgColor,
    max,
    maxLength = 10000,
    min
}) => {
    const errorMessage = warnMessage.text;
    const showMessage = errorMessage || Object.keys(subText).length;
    const acceptprop = fileAcceptType ? { accept: fileAcceptType } : {};
    switch (type) {
        case 'file':
            return (
                <Fragment>
                    <FileBoxStyle
                        isOutSide={outsideIcon}
                        isPlaceholder={!value}
                        check={check}
                        btbgColor={btbgColor}
                        errorLine={warnMessage.text && warnMessage.errorLine}
                        boxWidth={boxWidth}
                        boxMargin={boxMargin}
                        disabled={disabled}
                        disableEntireRow={disableEntireRow}
                    >
                        <div>
                            <span>
                                {value ? value : placeholder}
                            </span>
                            <label>
                                {check === "ekyc" ? "Upload" : "Choose File"}

                                {!disabled
                                    ? <input
                                        type='file'
                                        placeholder={'Choose File'}
                                        onChange={onChange}
                                        name={fieldName}
                                        {...acceptprop}
                                    /> : null}
                            </label>
                            {outsideIcon}
                        </div>
                        {showMessage ?
                            <MessageBelowBoxStyle
                                errorTextAlign={errorMessage && warnMessage.align}
                                subTextAlign={subText.align}
                                boxWidth={boxWidth}
                            >
                                <span>{warnMessage.text}</span>
                                <span> {subText.text}</span>
                            </MessageBelowBoxStyle>
                            : null}
                    </FileBoxStyle>
                </Fragment>
            )
        case 'textarea':
            return (
                <TextAreaStyle
                    errorLine={warnMessage.text}
                    boxWidth={boxWidth}
                    disabled={disabled}
                    background={background}
                    boxHeight={boxHeight}
                    isSKU={isSKU}

                >
                    <div style={{ ...customStyles }} >
                        <textarea
                            value={value}
                            placeholder={placeholder}
                            onChange={onChange}
                            name={fieldName}
                            disabled={disabled}
                            readOnly={readOnly || disabled}
                            tabIndex={disabled ? -1 : undefined}
                            max={max}
                            style={{ ...textareaStyles }}
                        />
                    </div>
                    {showMessage ?
                        <MessageBelowBoxStyle
                            errorTextAlign={errorMessage && warnMessage.align}
                            subTextAlign={subText.align}
                            boxWidth={boxWidth}
                        >
                            <span>{warnMessage.text}</span>
                            <span>{subText.text}</span>
                        </MessageBelowBoxStyle>
                        : null}
                </TextAreaStyle>
            )
        default:
            return (
                <TextBoxStyle
                    isOutSide={outsideIcon}
                    isSearchBox={isSearchBox}
                    errorLine={warnMessage.onlyTextError ? false : warnMessage.text}
                    onChange={onChange}
                    boxWidth={boxWidth}
                    disabled={disabled}
                    background={background}
                    boxHeight={boxHeight}
                    boxPadding={boxPadding}
                    boxMargin={boxMargin}
                    noBorder={noBorder}
                    className="textbox-wrapper"

                >
                    <div className="textbox-container">
                        <input
                            type={type}
                            value={value}
                            placeholder={placeholder}
                            onChange={onChange}
                            name={fieldName || name}
                            disabled={disabled}
                            readOnly={readOnly || disabled}
                            tabIndex={disabled ? -1 : undefined}
                            accept={fileAcceptType}
                            max={max}
                            min={min}
                            maxLength={maxLength}
                            onKeyDown={onEnter}
                        />
                        <span onClick={onClick}>{rightIcon}</span>
                        {outsideIcon && <OutSideIcon onClick={handleOutsideIconClick}>{outsideIcon}</OutSideIcon>}
                    </div>
                    {showMessage ?
                        <MessageBelowBoxStyle
                            errorTextAlign={errorMessage && warnMessage.align}
                            subTextAlign={subText.align}
                            boxWidth={boxWidth}
                            cursorPointer={Boolean(subText.onClick)}
                            subTextDisabled={subText.disabled}
                        >
                            <span style={warnMessage.position ? { position: warnMessage.position } : {}}>{warnMessage.text}</span>
                            <span onClick={() => !subText.disabled ? subText.onClick() : () => { }}>{subText.text}</span>
                        </MessageBelowBoxStyle>
                        : null}
                </TextBoxStyle>
            )
    }
}
